import React, { useState } from 'react';
import { useFormik } from 'formik';
import { Button, TextInput, ErrorMessage, Notice } from '@amtrav/view-components';
import ValidatorApi from '@amtrav/validator-api';
import { getHashSafeQueryString } from '@amtrav/jsr';
import styled from 'styled-components';
import axios from 'axios';
import { getTokenValue, THEME_TOKENS, media } from '@amtrav/theme-system';

/*
 *Join Meeting a.k.a. Gather - Book Travel:
 *This is the first step of the join-meeting a.k.a. book-travel page
 *After an email is entered, it will forward to the accept-invite page which is it's own app
 */

const FormContainer = styled.div`
  padding-top: 16px;
  display: flex;
  align-items: center;
  flex-direction: column;
  background-color: ${getTokenValue(THEME_TOKENS.base.color.white)};
  border: 1px solid ${getTokenValue(THEME_TOKENS.base.color.infoBorder)};
  width: 100%;
  border-radius: ${getTokenValue(THEME_TOKENS.card.size.borderRadiusMedium)};
`;

const TextInputContainer = styled.div`
  width: 280px;
`;

const StyledTextInput = styled(TextInput)`
  background-color: white;
`;

const FormFlexContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 12px;
  margin-top: 12px;

  ${media.Medium`
    flex-direction: row;
    align-items: flex-start;
    gap: 10px;
    padding-bottom: 0px;
  `};
`;

const validator = new ValidatorApi({
  rulesEndpoint: '/v1/validation?route=/v1/Account/SignUp&httpMethod=POST', // JOIN MEETING - BOOK TRAVEL
  baseURL: `${window.location.origin}/api`,
});

const getUrlParams = () => getHashSafeQueryString()?.params || {};
const { email: urlEmailValue } = getUrlParams();
const initialEmailValue = urlEmailValue && decodeURIComponent(urlEmailValue);

export const makeGetError = (formik) => (field) => formik.touched[field] ? formik.errors[field] : '';

// Basic test to make sure we aren't validating the same input repeatedly
const validationHandler = async (values) => {
  const errors = {};

  errors.email = await validator.validate('email', { email: values.email });

  // Removes the empty entries from the errors object. If the object is empty, it passes validation
  return Object.fromEntries(Object.entries(errors).filter((entry) => entry[1] !== ''));
};

const AcceptInviteForm = () => {
  const [isWaiting, setIsWaiting] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  // const [usingGoogle, setUsingGoogle] = useState(false);

  // This redirects to /accept-invite
  const getRedirectLink = async (email) => {
    const meetingGuid = window.location.pathname.split('/')[2];
    const url = `/api/v1/Meetings/ShareLinks/${meetingGuid}?email=${email}`;
    try {
      const response = await axios.get(url);

      window.location.href = response.data.redirectLink;

      return response;
    } catch (err) {
      // setIsLoading(false);
      setErrorMessage(err.response.data.message);
      // return generateError(err, 'An unexpected error ocurred.');
    }
    return null;
  };

  const formik = useFormik({
    initialValues: {
      firstName: '',
      middleName: '',
      lastName: '',
      suffixName: '',
      email: initialEmailValue || '',
      confirmEmail: initialEmailValue || '',
      password: '',
      confirmPassword: '',
      token: '',
    },
    validate: validationHandler,
    onSubmit: async (values) => {
      setIsWaiting(true);
      setErrorMessage(null);
      try {
        const response = await getRedirectLink(values.email);
        console.log('reponse: ', response);
        setIsWaiting(false);
      } catch (err) {
        console.error(err);
        setErrorMessage(err.message);
      } finally {
        setIsWaiting(false);
      }
    },
  });

  const getErrorByKey = makeGetError(formik);

  const { email } = formik.values;

  return (
    <>
      <FormContainer>
        <FormFlexContainer>
          <TextInputContainer>
            <StyledTextInput
              name="email"
              value={email}
              kind={getErrorByKey('email') ? 'danger' : undefined}
              onChange={formik.handleChange}
              placeholder="Enter your email to continue"
            />
            <ErrorMessage message={getErrorByKey('email')} />
          </TextInputContainer>
          <Button type="submit" text="Continue" onClick={formik.handleSubmit} isLoading={isWaiting} size="inlineForm" />
        </FormFlexContainer>
      </FormContainer>
      {errorMessage && (
        <Notice kind="danger" icon light>
          {errorMessage}
        </Notice>
      )}
    </>
  );
};

export default AcceptInviteForm;
